import { getKeyPrefix } from '@nucleus/ncu-key-prefix';
import { AuthorWeb } from '@nucleus/types/web/posts/author';
import { PostCollectionWeb } from '@nucleus/types/web/posts/post-collection';
import { PostTagWeb } from '@nucleus/types/web/posts/post-tag';
import { useLocalization } from './useLocalization';

export const useCollectionTerm = (collection: PostCollectionWeb | AuthorWeb | PostTagWeb): string => {
  const localize = useLocalization();
  const prefixKey = getKeyPrefix(collection.id);

  switch (prefixKey) {
    case 'postcollection':
      return localize('postCollection', 'Collection');
    case 'author':
      return localize('author', 'Author');
    case 'posttopic':
      return localize('topic', 'Topic');

    default:
      return ``;
  }
};
